import React, { useEffect, useState } from "react";
import logo from "../../assets/nutrackx.png";
import UserMenu from './userMenu'
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Drawer, Avatar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../../redux/userSlice";
import { emptyEmployee } from "../../redux/employeeSlice";
import { getRequest } from "../../utils/APICall";
import { HiOutlineLogout } from "react-icons/hi";
import {
  Bars3BottomRightIcon,
  XMarkIcon
} from "@heroicons/react/24/solid";

import UpdatePasswordModal from "../modal/updatePassword";
import LogoutModal from "../modal/logOutModal";
import * as Icons from "@heroicons/react/24/solid";
import { IconRenderer } from "./icons";
import { modalByPageName } from "../../config/modalConfig";
import ModalComponents from "../modal";
export const iconMap = Icons;
const Navbar = ({ setName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [updatePassModal, setUpdatePassModal] = useState(false);
  const [confrimModal, setConfrimModal] = useState(false);
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  const [menuItems, setMenuItems] = useState([]);

  const { users } = useSelector((state) => state.user || {});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Fetch allowed pages for role
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!users?.ROLEID) return;
      setLoadingPermissions(true);
      try {
        const res = await getRequest(`getUserControl?roleid=${users?.ROLEID}`);
        // console.log(res.data)
        if (res.success) {
          const allowedPages = res.data.filter(page => page.CAN_ACCESS === 1)
          // console.log(allowedPages.length)
          setMenuItems(allowedPages);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingPermissions(false);
      }
    };

    fetchPermissions();
  }, [users?.ROLE_ID]);

  const handleLogout = () => {
    dispatch(Logout());
    dispatch(emptyEmployee());
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
    setConfrimModal(false);
  };

  const handleUpdatePassword = () => {
    setUpdatePassModal(true);
  };
  return (
    <div className="sticky top-0 w-full bg-gray-200 dark:bg-gray-950 dark:text-white z-10">
      <div className="flex justify-between h-20 items-center shadow-md">
        <div className="flex items-center h-full">
          <Link to="/">
            <img src={logo} alt="Logo" width={150} height={150} />
          </Link>
          <UserMenu
            userRole={users?.ROLE_TITLE}
            username={`${users?.FIRSTNAME}  ${users?.LASTNAME ? users?.LASTNAME : ""}`}
            onLogout={handleLogout}
            onChangePassword={handleUpdatePassword}
          />
        </div>

        <div className="flex gap-4 pr-4">
          <button
            className="hidden md:flex items-center gap-2 px-2 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
            onClick={() => setConfrimModal(true)}
          >
            <HiOutlineLogout className="h-6 w-8 text-white" size={20} />
            Logout
          </button>
          <UpdatePasswordModal
            onUpdatePassword={handleUpdatePassword}
            setConfrimModal={setUpdatePassModal}
            confrimModal={updatePassModal}
          />
          <LogoutModal
            confrimModal={confrimModal}
            setConfrimModal={setConfrimModal}
            onLogout={handleLogout}
          />
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 focus:outline-none">
            {!isOpen ? <Bars3BottomRightIcon className="h-8 w-8" /> : <XMarkIcon className="h-8 w-8" />}
          </button>
        </div>
      </div>

      <Drawer
        title={
          <div className="flex items-center justify-center">
            <img
              src={logo}
              alt="Logo"
              className="bg-white p-2 rounded-full shadow-md"
              width={150}
              height={150}
            />
          </div>
        }
        placement="right"
        onClose={() => setIsOpen(false)}
        open={isOpen}
        className="!bg-gray-100"
      >
        {/* Menu Items */}
        <div className="space-y-2 w-full">
          {loadingPermissions ? (
            <>
              {Array.from({ length: 12 }).map((_, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 px-4 py-2 rounded-xl bg-gray-300 dark:bg-gray-700 animate-pulse">
                  <div className="w-4 h-4 bg-gray-400 dark:bg-gray-600 rounded"></div>
                  <div className="w-28 h-4 bg-gray-400 dark:bg-gray-600 rounded"></div>
                </div>
              ))}
            </>
          ) : (
            // Navbar Pages
            menuItems.map((item) => {
              if (item.PAGE_TYPE === "MODAL") {
                const ModalComponent = modalByPageName[item.PAGE_NAME];
                // console.log(ModalComponent)
                return (
                  <span
                    key={item.PAGE_ID}
                    className="flex items-center gap-3 px-4 py-1 rounded-xl w-full text-black font-semibold
                   hover:bg-primaryPurple hover:text-white hover:shadow-md hover:cursor-pointer"
                    onClick={() => setIsOpen(false)}
                  >
                    <IconRenderer iconName={item.ICONS} />
                    {ModalComponent && (
                      <ModalComponent
                        titles={item?.PAGE_NAME}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        message="responsive"
                        setName={setName}
                      />
                    )}
                  </span>
                );
              }
              return (
                <NavLink
                  key={item?.PAGE_ID}
                  to={item?.ROUTE}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-1 rounded-xl ${!isActive
                      ? "w-full text-black font-semibold hover:bg-primaryPurple hover:text-white hover:shadow-md"
                      : "bg-sunsetOrange font-bold text-white underline hover:text-black shadow-md"
                    }`
                  }
                  onClick={() => setIsOpen(false)}>
                  <IconRenderer iconName={item?.ICONS} />
                  {item?.PAGE_NAME}
                </NavLink>
              )
            })
          )}

          {!loadingPermissions &&
            <span
              className="flex items-center gap-3 px-4 py-2  rounded-xl   w-full  text-black font-semibold  "
            // onClick={() => setIsOpen(false)}  close on selected this tab
            >
              <button className="flex md:hidden w-full items-center justify-center gap-2 px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={() => setConfrimModal(true)}>
                <HiOutlineLogout className=" text-white" size={20} />
                Logout
              </button>
            </span>}

        </div>

      </Drawer>

    </div>
  );
};

export default Navbar;
